import { AppPermission, PermissionKey } from 'shared/types/app';

export const PERMISSIONS: Record<PermissionKey, AppPermission> = {
  login: 'demo-plq.login',
};
